<template>
  <div class="crossover">
    <v-head></v-head>
    <div class="crossover_banner"><img src="../../../static/images/fas_banner.jpg" alt=""></div>
    <div class="clearfix waterfall">
      {{{crossover_left}}}
      <!--<div class="crossover_left" >
        <img v-for="a in crossover_left" :src="url + a.src" alt="">
      </div>
      <div class="crossover_center">
        <img v-for="b in crossover_middle" :src="url + b.src" alt="">
      </div>
      <div class="crossover_right">
        <img v-for="c in crossover_right" :src="url + c.src" alt="">
      </div>-->
    </div>

    <v-footer></v-footer>
  </div>
</template>

<script>
  import head from 'components/head/head.vue';
  import footer from 'components/footer/footer.vue';
  export default {
    data () {
      return {
          url:"http://112.74.184.45:882/",
          crossover_left:[],
          crossover_middle:[],
          crossover_right:[],
      }
    },
    components: {
      "v-head": head,
      "v-footer": footer
    },
    ready () {
      var _this = this;
      $.ajax({
        type: "get",
        url: __formalUrl__ + "api/getNewsById/264",
        data:{} ,
        dataType: "json",
        success: function (data) {
          if (data) {
           console.log(111222,data)
            _this.crossover_left = data.content;
          }
        },
      });
      /*$.ajax({
        type: "get",
        url: "http://112.74.184.45:882/api/getImageByTypeId/20",
        data:{} ,
        dataType: "json",
        success: function (data) {
          if (data) {
              _this.crossover_left = data.data;
          }
        },
      });
      $.ajax({
        type: "get",
        url: "http://112.74.184.45:882/api/getImageByTypeId/21",
        data:{} ,
        dataType: "json",
        success: function (data) {
          if (data) {
            console.log(3333,data.data);
              _this.crossover_middle = data.data;
          }
        },
      });
      $.ajax({
        type: "get",
        url: "http://112.74.184.45:882/api/getImageByTypeId/22",
        data:{} ,
        dataType: "json",
        success: function (data) {
          if (data) {
              _this.crossover_right = data.data;
          }
        },
      });*/
    }
  }
</script>

<style>

  .waterfall{  -moz-column-count:3; /* Firefox */  -webkit-column-count:3; /* Safari 和 Chrome */  column-count:3;  -moz-column-gap: 2px;  -webkit-column-gap:2px;  column-gap:2px;-moz-column-width: 2.94rem;  -webkit-column-width:2.94rem;  column-width:2.94rem;-webkit-column-break-inside: avoid;  page-break-inside: avoid;  break-inside: avoid; }
  .crossover{width:9rem;margin: 0.5rem auto}
  .crossover_banner{margin-top: 0.5rem;width: 9rem;}
  .crossover_banner img{width: 100%}
  .crossover_left{width: 2.94rem;overflow: hidden;float: left;margin-right: 0.05rem }
  .crossover_center{width:2.94rem;overflow: hidden;float: left;margin-right: 0.05rem }
  .crossover_right{width: 2.94rem;overflow: hidden;float: left}
  @media screen and (max-width: 30em) and (min-width:20em ){
    .waterfall img{width: 100%}
    .crossover{width:100% !important;margin:0rem auto}
    .crossover_banner{margin-top: 0rem;width: 100%;}
    .crossover_banner img{width: 100%}
    .crossover_left{width: 100%;overflow: hidden;margin-right: 0rem }
    .crossover_left img{width: 100%;height: 100%}
    .crossover_center{width:100%;overflow: hidden;margin-right: 0rem }
    .crossover_center img{width: 100%;height: 100%}
    .crossover_right{width: 100%;overflow: hidden}
    .crossover_right img{width: 100%;height: 100%}
  }
</style>




// WEBPACK FOOTER //
// crossover.vue?5c65fda8